export default "__VITE_ASSET__0a61835e__"